import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Divider, Layout, Typography } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { iconMapping } from '../../../configs/AppsConfig';

import PortfoliosTable from './components/PortfoliosTable';
import PageHeader from '../../../layouts/PageHeader';
import Placeholder from "../../../components/Placeholder";

import { selectPortfoliosWithUserUpdates } from "../../../store/slices/portfolios.slice";
import { selectUserFields } from '../../../store/slices/user.slice';
import usePortfoliosCollection from "./usePortfoliosCollection";
import useCompany from "../../Company/useCompany";



const Empty = ()=>{
    const navigate = useNavigate();
    const Buttons = ()=> (
        <ButtonGroup>
            <Button variant={'contained'} onClick={() => navigate('/builders/model')}>Personalize Model</Button>
            <Button variant={'text'} onClick={() => navigate('/builders/portfolio')}>Build Sleeve</Button>
        </ButtonGroup>
    )
    return (
        <Placeholder text={'No Portfolios Available'}
                           action={<Buttons/>}
                />
    )
}

const PortfoliosCollection = () => {
    const { formattedPortfolios } = usePortfoliosCollection();
    const isLoading = useSelector((state) => state.portfolios.loading);
    const { allowAdminActions} = useCompany();
    const allPortfolioIds = useSelector((state) => state.user.data.portfolios_v2);
    const idsAlreadyFetched = useSelector((state) => state.portfolios.items?.filter(x=>allPortfolioIds.includes(x.id)).map(x=>x.id));

    // const portfolioPrefix = useSelector((state) => selectUserFields(state, 'settings.portfolio_prefix'));
    
    if (isLoading) return <Placeholder text="Loading portfolios..." />;

    return (
          <div>
              {formattedPortfolios.length > 0 ? (
                <PortfoliosTable portfolios={formattedPortfolios} prefix={''} />
              ) : <Empty />}
          </div>
  );
};

export default PortfoliosCollection;